<template>
  <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      autocomplete="off"
    >
    <v-container v-if="!submitted"  style="max-width: 1200px;">
      <v-row>
            <template v-for="(value, name) in agencyData">
              <v-col :cols="value.cols" class="py-0 my-0" :key="name">
              
                    <v-textarea
                      v-model="agencyData[name].data"
                      v-if="value.type === 'textarea' && name !== 'eligibility_requirments'"
                      :rules="new_rules(name)"
                      :label="value.label+has_rules(name)"
                      :hint="value.hint"
                      outlined 
                      filled
                    >
                    </v-textarea>
                    <v-text-field
                      v-else-if="value.type === 'text'"
                      :rules="new_rules(name)"
                      v-model="agencyData[get_data_field(name)].data"
                      :label="value.label+has_rules(name)"
                      :hint="value.hint"
                      :disabled="get_data_field(name) !== name"
                      outlined
                      filled
                    ></v-text-field>
                    <v-checkbox 
                      color="primary"
                      v-else-if="value.type === 'boolean'"
                      :rules="new_rules(name)"
                      v-model="agencyData[name].data" 
                      class="mx-2" 
                      :label="value.label+has_rules(name)">
                    </v-checkbox>
                    <v-autocomplete
                      autocomplete="new-password"
                      v-else-if="value.type === 'dropdown'"
                      :rules="new_rules(name)"
                      v-model="agencyData[get_data_field(name)].data"
                      :hint="value.hint"
                      :items="value.items"
                      :label="value.label+has_rules(name)"
                      :disabled="get_data_field(name) !== name"
                      persistent-hint
                      outlined
                      filled
                    >
                    </v-autocomplete>
                     <v-btn
                      v-else-if="value.type === 'action'"
                      :to="value.to"
                      large
                      outlined
                      filled
                      block
                      class="py-7"
                     >
                     
                      {{ value.data }}
                      <v-icon right>mdi-pencil</v-icon> 
                    </v-btn>
                    <v-text-field
                        v-else-if="value.type === 'phone'"
                        :rules="new_rules(name)"
                        v-model="agencyData[name].data"
                        :label="value.label+has_rules(name)"
                        :hint="value.hint"
                        return-masked-value
                        v-mask="'(###) ###-####'"
                        outlined
                        filled
                    ></v-text-field>

                    <v-combobox
                      autocomplete="new-password"
                      v-else-if="value.type === 'array'"
                      :rules="new_rules(name)"
                      v-model="agencyData[name].data"
                      :items="[]"
                      hide-selected
                      append-icon=""
                      clearable
                      :hint="value.hint"
                      deletable-chips
                      
                      :label="value.label+has_rules(name)"
                      multiple
                      persistent-hint
                      outlined
                      filled
                      small-chips>
                      <template slot="no-data">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              Type in something then press <kbd>enter</kbd>
                            </v-list-item-title>
                            
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-combobox>
                    <v-row class="mt-0 pt-0" v-else-if="value.type === 'office_hours'">
                      <v-col cols="12" class="my-0 py-0">
                        <v-divider  />
                        {{ value.label+has_rules(name) }}
                      </v-col>
                      <v-col cols="4" class="my-0 py-0">
                          <v-autocomplete
                            autocomplete="new-password"
                            :error="workdaysError"
                            v-model="workdays.day"
                            dense
                            :items="days"
                            label="Day of week"
                          >
                          </v-autocomplete>
                      </v-col>
                      <v-col cols="3" class="my-0 py-0">
                          <v-autocomplete
                            autocomplete="new-password"
                            :error="workdaysError"
                            v-model="workdays.open"
                            dense
                            :items="openTimes"
                            label="Open Time"
                            persistent-hint
                          >
                          </v-autocomplete>
                      </v-col>
                      <v-col cols="3" class="my-0 py-0">
                          <v-autocomplete
                            autocomplete="new-password"
                            :error="workdaysError"
                            v-if="!hideClose"
                            v-model="workdays.close"
                            dense
                            :items="closeTimes"
                            label="Close Time"
                            persistent-hint
                          >
                          </v-autocomplete>
                      </v-col>
                      <v-col class=""  cols="2">
                        <v-btn @click="add_workday(name)" small block color="primary">Add</v-btn>
                      </v-col>
                      <v-col class="pt-0 ma-0" cols="12">
                        <v-autocomplete
                          v-model="agencyData[name].data"
                          :rules="new_rules(name)"
                          :items="agencyData[name].data"
                          hide-selected
                          append-icon=""
                          clearable
                          :hint="value.hint"
                          deletable-chips
                          :label="value.label+has_rules(name)"
                          multiple
                          persistent-hint
                          outlined
                          filled
                          small-chips>
                          <template slot="no-data">
                               <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    Choose Day of Week and Time above and click add to enter your Office Hours.
                                  </v-list-item-title>
                                  
                                </v-list-item-content>
                              </v-list-item>
                          </template>
                        </v-autocomplete>
                      </v-col>
                       <v-col cols="12">
                        <v-divider  />
                      </v-col>
                    </v-row>
                    <template v-else-if="value.type === 'eligibility'">
                      <v-row>
                      <v-col  cols="8">
                       <v-autocomplete
                          clearable
                          :rules="new_rules(name)"
                          v-model="agencyData[name].data"
                          :items="value.items"
                          :hint="value.hint"
                          :label="value.label+has_rules(name)"
                          multiple
                          small-chips
                          deletable-chips
                          outlined
                          filled
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col  cols="4">
                        <v-btn width="100%" large  color="primary" @click="showOther = !showOther">Expand on Eligibility Requirements</v-btn>
                      </v-col>
                      </v-row>
                       <v-expand-transition>
                        <div
                          v-if="showOther"
                          class="d-flex transition-fast-in-fast-out"
                        >
                        <v-textarea
                              v-model="agencyData['eligibility_requirments'].data"
                              :rules="new_rules('eligibility_requirments')"
                              :label="agencyData['eligibility_requirments'].label"
                              :hint="agencyData['eligibility_requirments'].hint"
                              outlined 
                              filled
                          >
                          </v-textarea>
                          </div>
                      </v-expand-transition>
                    </template>
                    <v-autocomplete
                      clearable
                      v-else-if="value.type === 'multichoice'"
                      :rules="new_rules(name)"
                      v-model="agencyData[name].data"
                      :items="value.items"
                      :hint="value.hint"
                      :label="value.label+has_rules(name)"
                      multiple
                      small-chips
                      deletable-chips
                      outlined
                      filled
                    >
                    </v-autocomplete>
              </v-col>
            </template>

            <v-col cols="12">
             <v-alert v-if="!valid" type="error">
                Not all required fields are filled out or some fields may have invalid entries.
              </v-alert>
               <p class="text-right"><v-btn color="primary" @click="submit">Submit</v-btn></p>
            </v-col>
      </v-row>
    </v-container>
      <v-container
        v-if="submitted"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Thank you</v-toolbar-title>
                <div class="flex-grow-1"></div>
           
     
              </v-toolbar>
              <v-card-text>
                <h3 v-if="formData == 'agencyData'">Thank you for your submission, please click the button below to submit programs associated with your agency.</h3>
                <h3 v-else>Thank you for your submission, please click the button below to add another program.</h3>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn v-if="formData == 'agencyData'" to="program" color="primary">Programs</v-btn>
                <v-btn v-else @click="AddProgram" color="primary">Add Another Program</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
  </v-form>
</template>
<script>
import axios from 'axios';
export default {
  mounted() {
    if (this.$store.state.agencyData.agency_name.data) {
      this.$store.state.programData.agency_name.data = this.$store.state.agencyData.agency_name.data;
    }
    //console.log('mount');
  },
  data: () => ({
    showOther: false,
    instance: axios.create(),
    submitted: false,
    valid: false,
    dynamicListSearch: '',
    workdays: {
      day: 'Monday',
      open: '',
      close: '',
    },
    workdaysError: false,
    hideClose: false,
    days: [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ],
    rules : {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          if (!value) {
            value = 'test@test.com'
          }
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
         },
         array_required: value => value.length > 0 || 'Required.',
}
  }),
  props: {
    formData: String,
  },
  computed: {
    update: {
       get() {
          return this.$store.state['update'];
        },
        set(value) {
          this.$store.commit("set_update", value);
        }
     },
     agencyData: {
       get() {
          return this.$store.state[this.formData];
        },
        set(value) {
          this.$store.commit("set_"+this.formData, value);
        }
     },
     blankData() {
       return this.$store.state[this.formData+'Blank'];
     },
     openTimes() {
        let openTimes = JSON.parse(JSON.stringify(this.hours));
        openTimes.unshift('Closed', '24 Hours');
        return openTimes;
     },
     closeTimes() {
       return this.hours;
     },
     hours()  {
       let hours = [];
        hours.push('12:00 am');
        hours.push('12:15 am');
        hours.push('12:30 am');
        hours.push('12:45 am');
        for (var i = 1; i < 12; i++) {
          hours.push(i + ':00 am');
          hours.push(i + ':15 am');
          hours.push(i + ':30 am');
          hours.push(i + ':45 am');
        }
        hours.push('12:00 pm');
        hours.push('12:15 pm');
        hours.push('12:30 pm');
        hours.push('12:45 pm');
        for (i = 1; i < 12; i++) {
          hours.push(i + ':00 pm');
          hours.push(i + ':15 pm');
          hours.push(i + ':30 pm');
          hours.push(i + ':45 pm');
        }
        return hours;
     }
  },
  methods: {
    get_data_field(key) {
      if (this.agencyData[key].hasOwnProperty('dupifcheck')) {
        if (this.agencyData[this.agencyData[key].dupifcheck.checkbox].data == true) {
          let dupdata = JSON.parse(JSON.stringify(this.agencyData[this.agencyData[key].dupifcheck.field_to_dup]));
          this.agencyData[key].data = dupdata.data;
          return this.agencyData[key].dupifcheck.field_to_dup;
        }
      }
      return key;
    },
    has_rules(key) {
        let rules = this.agencyData[key].rules;
        if (this.update) {
          if (this.agencyData[key].hasOwnProperty('update_rules')) {
            rules = this.agencyData[key].update_rules;
          } else {
            rules = [];
          }
        }
        if (rules.indexOf('required') !== -1) {

          return ' *'
        }
        return '';
    },
    new_rules(key) {
        let rules = this.agencyData[key].rules;
        if (this.update) {
          if (this.agencyData[key].hasOwnProperty('update_rules')) {
            rules = this.agencyData[key].update_rules;
          } else {
            rules = [];
          }
        }

        return this.getRealRules(rules);
    },
    AddProgram(){
      this.agencyData = JSON.parse(JSON.stringify(this.blankData))
      this.submitted = false;
    },
    add_workday(name) {
      let timeRange = '';
      let validate = true;
      if (this.workdays.open == '24 Hours' || this.workdays.open == 'Closed') {
        timeRange = this.workdays.open;
        if (!this.workdays.day) {
          validate = false;
        }
      } else {
        timeRange = this.workdays.open+' - '+this.workdays.close
        if (!this.workdays.day || !this.workdays.open || !this.workdays.close) {
          validate = false;
        }
      }
      if (validate) {
        let newDate = this.workdays.day+', '+timeRange;
        this.agencyData[name].data.push(newDate);
        if (this.workdays.day == 'Sunday') {
          this.workdays.day = 'Monday'
        } else if (this.workdays.day == 'Monday') {
          this.workdays.day = 'Tuesday'
        } else if (this.workdays.day == 'Tuesday') {
          this.workdays.day = 'Wednesday'
        } else if (this.workdays.day == 'Wednesday') {
          this.workdays.day = 'Thursday'
        } else if (this.workdays.day == 'Thursday') {
          this.workdays.day = 'Friday'
        } else if (this.workdays.day == 'Thursday') {
          this.workdays.day = 'Friday'
        } else if (this.workdays.day == 'Friday') {
          this.workdays.day = 'Saturday'
        } else if (this.workdays.day == 'Saturday') {
          this.workdays.day = 'Sunday'
        }
        //this.workdays.open = '';
        //this.workdays.close = '';
        this.workdaysError = false;
      } else {
        this.workdaysError = true;
      }
    },
    getRealRules (rules) {
      let realRules = [];
       rules.forEach((rule) => {
          realRules.push(this.rules[rule]);
       });
       return realRules;
    },
    submit () {
        if (this.$refs.form.validate()) {
          this.submitted = true;
          this.errors = false;
           let data = JSON.parse(JSON.stringify(this.agencyData));
            if (this.update) {
              data['Form Type'] = 'UPDATE FORM';
            } else {
              data['Form Type'] = 'NEW FORM'
            }
              this.instance.post("/formData.php", data).then(
                response => {
                    //console.log(response);
                },
                response => {
                    //error
                }
            );
        }
      
    },
    error_messages(field_name, errors) {
       //console.log(errors);
       let newErrors = [];
       for (let error in errors) {
         newErrors.push(errors[error].replace('The {field} field', '"'+field_name+'"'));
       }
       return newErrors;
    }
  },
  watch: {
    agencyData: {
      deep: true,
      handler() {
        this.agencyData = this.agencyData;
      }
    },
    workdays: {
      deep: true,
      handler() {
        if (this.workdays.open == 'Closed' || this.workdays.open == '24 Hours') {
           this.hideClose = true;
        } else {
          this.hideClose = false;
        }
      }
    }
  }
};
</script>